module.exports = __webpack_public_path__ + "img/public/SiteIcons/refund.svg?b66b5fd9";